var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7C19.923 5.58273 19.7125 4.6644 19.1364 3.96243C18.9702 3.75989 18.7844 3.57418 18.5819 3.40796C17.4756 2.5 15.8318 2.5 12.5443 2.5L12 2.50016C8.22876 2.50016 6.34315 2.50016 5.17157 3.67173C4 4.84331 4 6.72892 4 10.5002V13.5002C4 17.2714 4 19.157 5.17157 20.3286C6.34315 21.5002 8.22876 21.5002 12 21.5002L12.5443 21.5C15.8318 21.5 17.4756 21.5 18.5819 20.592C18.7844 20.4258 18.9702 20.2401 19.1364 20.0376C19.7125 19.3356 19.923 18.4173 20 17",
    stroke: "#161A1F",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 8 20 10.946 20 12C20 13.0541 16 16 16 16M19.5 12H9",
    stroke: "#161A1F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2e1917601353d1fe95d175ca0039dbe6.svg";
export { ForwardRef as ReactComponent };